const assertParamFactory = (tag
/*: string*/
) => (paramName
/*: string*/
, param
/*: **/
) => {
  if (param == null) throw new Error(`${tag} missing expected param ${paramName}.`);
};

module.exports.assertParamFactory = assertParamFactory;